import { render, staticRenderFns } from "./reports-rams-to-be-updated.vue?vue&type=template&id=c10f805e"
import script from "./reports-rams-to-be-updated.vue?vue&type=script&lang=js"
export * from "./reports-rams-to-be-updated.vue?vue&type=script&lang=js"
import style0 from "./reports-rams-to-be-updated.vue?vue&type=style&index=0&id=c10f805e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports